import { ButtonVariant as LegacyButtonVariant } from '@/components/OldButton/OldButton';
import { ButtonVariant } from './Button';

// Keyed by string rather than LegacyButtonVariant because the CMS `button`
// content type's actual validation list (see TypeButton.ts) includes values
// like `TextOnlyOffWhite` that were never added to the OldButton enum.
const legacyToButtonVariant: Record<string, ButtonVariant> = {
  [LegacyButtonVariant.PrimaryBluePill]: ButtonVariant.PRIMARY,
  [LegacyButtonVariant.WhitePill]: ButtonVariant.PRIMARY,
  [LegacyButtonVariant.OffWhitePill]: ButtonVariant.PRIMARY,
  [LegacyButtonVariant.TransparentPillArrowPrimary]: ButtonVariant.SECONDARY,
  [LegacyButtonVariant.TransparentPillArrowLight]: ButtonVariant.SECONDARY,
  [LegacyButtonVariant.OffWhitePillPrimaryBlueOutline]: ButtonVariant.SECONDARY,
  [LegacyButtonVariant.TransparentPillPrimaryBlueOutline]:
    ButtonVariant.SECONDARY,
  [LegacyButtonVariant.TransparentPillWhiteOutline]: ButtonVariant.SECONDARY,
  [LegacyButtonVariant.TransparentPrimaryBlueText]: ButtonVariant.TERTIARY,
  [LegacyButtonVariant.TransparentWhiteText]: ButtonVariant.TERTIARY,
  [LegacyButtonVariant.OffWhiteCircleArrow]: ButtonVariant.TERTIARY,
  [LegacyButtonVariant.ArrowOnlyOffWhite]: ButtonVariant.TERTIARY,
  [LegacyButtonVariant.Arrow]: ButtonVariant.TERTIARY,
  TextOnlyOffWhite: ButtonVariant.TERTIARY,
};

/**
 * Maps the legacy CMS `button.variant` field (still authored by editors today)
 * to the BaseLibrary `ButtonVariant` used by the current Button component.
 */
export function mapLegacyButtonVariant(
  legacyVariant: string | undefined,
  fallback: ButtonVariant
): ButtonVariant {
  if (!legacyVariant) {
    return fallback;
  }

  return legacyToButtonVariant[legacyVariant] ?? fallback;
}
